/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Started_AtInputs */

const vi_trip_started_at = /** @type {(inputs: Trip_Started_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu`)
};

/**

* @param {Trip_Started_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_started_at = /** @type {((inputs?: Trip_Started_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Started_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_started_at(inputs)
});